(function () {
    'use strict';

    var $ = require('jquery');
    var $flexslider = $('.vc-techniques .flexslider');

    if ($flexslider.length > 0) {

        $flexslider.flexslider({
            slideshow:  false,
            animation: 'slide',
            manualControls: '.vc-techniques .flex-control-nav li',
            directionNav: false,
            useCSS: false
        });

    }

})();